import React from "react";

export function TijucaNelsonMandela() {
  return (
    <svg
    xmlns="http://www.w3.org/2000/svg"
    data-name="Camada 1"
    viewBox="0 0 60 60"
  >
    <defs>
      <linearGradient
        id="a"
        x1={42.68}
        x2={15.97}
        y1={52.24}
        y2={14.09}
        data-name="Gradiente sem nome 7"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset={0} stopColor="#23bcef" />
        <stop offset={1} stopColor="#004b80" />
      </linearGradient>
    </defs>
    <path
      d="M45.26 37.47v-.11c0-.04-.02-.08-.04-.12-.01-.06-.03-.12-.05-.18a.864.864 0 0 0-.1-.16c-.03-.05-.07-.09-.1-.13a.657.657 0 0 0-.17-.12c-.03-.02-.06-.05-.09-.06-.03-.01-.06-.02-.1-.04h-.01c-5.17-2.3-11.23-.04-13.64 5.08v-7.81c5.35 2.16 11.43-.43 13.59-5.78.62-1.53.86-3.19.72-4.83v-.12l-.09-.3a.843.843 0 0 0-.38-.41l-.09-.06-.09-.03h-.02c-5.17-2.3-11.23-.04-13.64 5.08v-4.9c4.83-3.14 6.21-9.6 3.08-14.43-.88-1.36-2.06-2.49-3.45-3.31h-.01s-.06-.05-.09-.07c-.04-.01-.07-.03-.11-.04a.603.603 0 0 0-.19-.06.87.87 0 0 0-.55.06c-.04 0-.07.02-.11.04l-.09.06h-.01c-4.96 2.94-6.61 9.33-3.68 14.3.82 1.39 1.95 2.57 3.31 3.45v4.9c-2.43-5.16-8.56-7.41-13.75-5.04-.04.02-.08.05-.12.08-.05.03-.09.06-.13.1-.09.09-.16.19-.22.29-.03.06-.05.13-.06.19-.01.04-.03.07-.03.11v.11c-.52 5.75 3.72 10.83 9.46 11.34 1.65.15 3.31-.1 4.84-.72v7.81c-2.43-5.16-8.56-7.41-13.75-5.04-.04.03-.08.05-.12.09l-.12.09c-.05.05-.09.1-.13.16-.03.04-.06.09-.09.14-.03.06-.05.13-.06.19-.01.04-.03.07-.03.11v.11c-.52 5.75 3.72 10.83 9.46 11.34 1.65.15 3.31-.1 4.84-.72v5.58h-6.66a.95.95 0 1 0 0 1.9h15.22a.95.95 0 1 0 0-1.9h-6.66v-5.58c5.35 2.16 11.43-.43 13.59-5.78.62-1.53.86-3.19.72-4.83v-.01Zm-9.87-12.58a8.6 8.6 0 0 1 7.99-1.05c.17 4.7-3.5 8.65-8.19 8.82-.73.03-1.47-.04-2.18-.2l4.39-3.15c.43-.31.52-.9.22-1.33s-.9-.52-1.33-.22l-4.39 3.15a8.55 8.55 0 0 1 3.5-6.02Zm-9.2-11.18A8.591 8.591 0 0 1 30 6.61a8.51 8.51 0 0 1 2.39 11.8c-.41.61-.89 1.17-1.44 1.65v-5.4a.95.95 0 1 0-1.9 0v5.4a8.573 8.573 0 0 1-2.85-6.36Zm-6.02 17.36a8.587 8.587 0 0 1-3.55-7.23c4.4-1.67 9.31.54 10.98 4.94.26.69.43 1.4.51 2.13l-4.39-3.15c-.43-.31-1.02-.21-1.33.22s-.21 1.02.22 1.33L27 32.46c-2.37.52-4.85.02-6.83-1.39Zm0 14.28a8.587 8.587 0 0 1-3.55-7.23c4.4-1.67 9.31.54 10.98 4.94.26.69.43 1.4.51 2.13l-4.39-3.15c-.43-.31-1.02-.21-1.33.22s-.21 1.02.22 1.33L27 46.74c-2.37.52-4.85.02-6.83-1.39Zm19.66 0A8.593 8.593 0 0 1 33 46.74l4.39-3.15c.43-.31.52-.9.22-1.33s-.9-.52-1.33-.22l-4.39 3.15a8.51 8.51 0 0 1 9.35-7.58 8.6 8.6 0 0 1 2.13.51 8.587 8.587 0 0 1-3.55 7.23Z"
      style={{
        fill: "url(#a)",
        strokeWidth: 0,
      }}
    />
  </svg>
  );
}
